import S from './FarmInfo.module.css'
import G from './SingleDam.module.css'
import F from '../images/damdari.svg'
import { Fax, HomeWork, Edit,LocationOn, PersonPin, Phone, PhoneIphone, RateReview } from '@mui/icons-material'

import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';

import { useGlobalContext } from '../Components/Context';
import { loginSuccessS } from '../redux/slices/singleFarmSlice';
import EditFarms from '../Components/editModalFarm';
import DeleteFarms from '../Components/DeleteFarm';
import DeleteIcon from '@mui/icons-material/Delete';

import apiService from '../api/ApiService';
import { Box, Tab } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@material-ui/lab';
import { useState } from 'react';
import CommentsListComp from './CommentsPageComp';
import AddComment from '../Components/AddCattleComment';
import { showUserExtra } from '../api/helper';


const FarmInfo=()=>{
    const dispatch=useDispatch()
    const {openModalls,isOpenModal,openDeleteModal,isDeleteModalOpen,openModallComment,isModalCommentOpen}=useGlobalContext()
    const [value, setValue] = useState('1');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
    const {currentSfarm}=useSelector(state=>state.p.sFarm)
    const {currentAdmin}=useSelector(state=>state.p.admin)
    const getData=async()=>{
        const res=await apiService.getFarmInfo(currentAdmin.id)
        dispatch(loginSuccessS(res.data))
    }
    useEffect(()=>{
        getData()
    },[])
    return <>
    <div className={S.FarmInfoCon}>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
        <div className={S.FarmInfoHead}>
            <img className={S.FarmInfoImg} src={F}/>
            <h2>دامداری</h2>
        </div>
        {showUserExtra&&<div style={{display:'flex',gap:'10px'}}>
        <div onClick={openModalls} className={S.EditBtnTableDam}>
                <Edit sx={{fontSize: { xs: 26, sm: 30, md: 30, lg:30} }}/>
            </div>
            <div onClick={()=>openDeleteModal()} className={S.DeleteBtnTableDam}>
                <DeleteIcon sx={{fontSize: { xs: 26, sm: 30, md: 30, lg:30} }}/>
            </div>
            
        </div>}
        </div>
        <Box sx={{ width: '100%', typography: 'body1' }}>
      <TabContext value={value}>
        <Box >
          <TabList onChange={handleChange} aria-label="lab API tabs example">
            <Tab label="اطلاعات دامداری" value="1" />
            <Tab label="یادداشت های دامداری" value="2" />
          </TabList>
          <hr style={{marginTop:'-3px'}}/>
        </Box>
        <TabPanel value="1"><table className={S.FarmInfoTable}>
            <tbody style={{margin:'0px auto'}}>
                <tr>
                    <td className={S.LogoFormT}><span>
                    <HomeWork/></span></td>
                    <td className={S.TableFormTit}>عنوان</td>
                    <td>{currentSfarm&&currentSfarm?.name}</td>
                </tr>
                <tr>
                    <td className={S.LogoFormT}><span><LocationOn/></span></td>
                    <td className={S.TableFormTit}>آدرس</td>
                    <td>{currentSfarm&&currentSfarm?.address}</td>
                </tr>
                <tr>
                    <td className={S.LogoFormT}><span>
                    <Phone/></span></td>
                    <td className={S.TableFormTit}>تلفن</td>
                    <td>{currentSfarm&&currentSfarm?.phone}</td>
                </tr>
                <tr>
                    <td className={S.LogoFormT}><span>
                    <Fax/></span></td>
                    <td className={S.TableFormTit}>فکس</td>
                    <td>{currentSfarm&&currentSfarm?.fax}</td>
                </tr>
                <tr>
                    <td className={S.LogoFormT}><span>
                    <PersonPin/></span></td>
                    <td className={S.TableFormTit}>مالک</td>
                    <td>{currentSfarm&&currentSfarm?.ownerName}</td>
                </tr>
                <tr>
                    <td className={S.LogoFormT}><span><PhoneIphone/></span></td>
                    <td className={S.TableFormTit}>تلفن مالک</td>
                    <td>{currentSfarm&&currentSfarm?.ownerPhone}
</td>
                </tr>
            </tbody>
        </table></TabPanel>
        <TabPanel value="2">
            
            <CommentsListComp flag={'farm'} farmId={currentAdmin?.id}/>
        </TabPanel>
        
      </TabContext>
    </Box>
        
        
    </div>
    
    {isOpenModal&&<EditFarms data={currentSfarm}/>}
    {isDeleteModalOpen&&<DeleteFarms/>}
    </>
}
export default FarmInfo